import "./style.scss";
import Logo from "@/src/assets/Header/header-logo.png";
import { headerNavLinks, headerTabsMenu } from "@/src/constants/header";
import { Link } from "react-router-dom";
import { ArrowDown } from "@/src/svg/ArrowDown";
import { Phone } from "@/src/svg/Phone";
import { Mail } from "@/src/svg/Mail";
import { Facebook } from "@/src/svg/Facebook";
import { Instagram } from "@/src/svg/Instagram";
import { Linkedin } from "@/src/svg/Linkedin";
import { Youtube } from "@/src/svg/Youtube";
import { Tiktok } from "@/src/svg/Tiktok";
import { useEffect, useRef, useState } from "react";
import HeaderDeskSubMenu from "./HeaderDeskSubMenu/HeaderDeskSubMenu";
import HeaderDeskActivePanel from "./HeaderDeskActivePanel/HeaderDeskActivePanel";

const HeaderDesk = () => {
  const [activeTab, setActiveTab] = useState<string>("menu");
  const [absolutActiveTab, setAbsolutActiveTab] = useState<string | null>(null);
  const [activeMenuId, setActiveMenuId] = useState<string | null>();
  const hideTimeout = useRef<ReturnType<typeof setTimeout> | null>(null);
  const [isHovering, setIsHovering] = useState<boolean>(false);

  const handleMouseEnterZone = () => {
    setActiveTab("menu");
    setAbsolutActiveTab(null);
    if (hideTimeout.current) clearTimeout(hideTimeout.current);
    setIsHovering(true);
    document.body.classList.add("hidden");
  };

  const handleMouseLeaveZone = () => {
    hideTimeout.current = setTimeout(() => {
      setIsHovering(false);
      setActiveMenuId(null);
      document.body.classList.remove("hidden");
    }, 300);
  };

  const handleMouseEnter = (id: string) => {
    setActiveTab("menu");
    setAbsolutActiveTab(null);
    if (hideTimeout.current) {
      clearTimeout(hideTimeout.current);
    }

    const hasSubmenu = headerNavLinks.find((item) => item.id === id && item.submenu);
    if (hasSubmenu) {
      setActiveMenuId(id);
    } else {
      setActiveMenuId(null);
    }
  };

  const handleTabClick = (id: string) => {
    setActiveTab(id);
    if (absolutActiveTab === id) {
      setAbsolutActiveTab(null);
      document.body.classList.remove("hidden");
    } else {
      document.body.classList.add("hidden");
      setAbsolutActiveTab(id);
    }
  };

  const activeSubmenu = headerNavLinks.find((item) => item.id === activeMenuId)?.submenu ?? [];

  useEffect(() => {
    return () => {
      if (hideTimeout.current) {
        clearTimeout(hideTimeout.current);
      }
    };
  }, []);

  useEffect(() => {
    if (activeMenuId) {
      document.body.classList.add("body-blur-overlay");
    } else {
      document.body.classList.remove("body-blur-overlay");
    }

    return () => {
      document.body.classList.remove("body-blur-overlay");
    };
  }, [activeMenuId]);

  useEffect(() => {
    if (!absolutActiveTab) {
      setActiveTab("menu");
    }
  }, [absolutActiveTab]);

  return (
    <div className="header-wrapper">
      <section className="header">
        <div className="container">
          <Link className="header-logo" to={"/"}>
            <img src={Logo} alt="Logo" />
          </Link>
          <div className="header-content">
            <div className="header-social">
              <div className="header-social-links">
                <div className="header-social-links-phone">
                  <Phone />
                  <p>+998 90 006 44 43</p>
                </div>
                <div className="header-social-links-phone">
                  <Phone />
                  <p>+998 95 794 44 42</p>
                </div>
                <a href="mailto:info@msmbmalta.com" className="header-social-links-mail">
                  <Mail />
                  <p>info@msmbmalta.com</p>
                </a>
              </div>
              <div className="header-social-networks">
                <Facebook />
                <Instagram />
                {/* <Linkedin /> */}
                {/* <Youtube /> */}
                <Tiktok />
              </div>
              <div className="header-social-language">
                <span>РУ</span>
                <ArrowDown />
              </div>
            </div>
            <div
              className="header-links"
              onMouseEnter={handleMouseEnterZone}
              onMouseLeave={handleMouseLeaveZone}
            >
              {headerNavLinks.map((item) => (
                <Link
                  to={item.link}
                  key={item.id}
                  onMouseEnter={() => handleMouseEnter(item.id.toString())}
                >
                  {item.text}
                </Link>
              ))}
            </div>
          </div>
          <div className="header-tabs">
            {headerTabsMenu.map((item) => (
              <div className="header-tabs-first" key={item.id}>
                <div className="header-tabs-second">
                  <div
                    className={`header-tabs-content
                      ${activeTab === item.id ? "active" : ""}
                      ${absolutActiveTab === item.id ? "absolut-active" : ""}
                    `}
                    onClick={() => handleTabClick(item.id)}
                  >
                    {absolutActiveTab === item.id ? <item.activeIcon /> : <item.icon />}
                    <p>{item.text}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <HeaderDeskSubMenu
        isHovering={isHovering}
        setIsHovering={setIsHovering}
        activeSubmenu={activeSubmenu}
        activeMenuId={activeMenuId}
        handleMouseEnterZone={handleMouseEnterZone}
        handleMouseLeaveZone={handleMouseLeaveZone}
      />
      <HeaderDeskActivePanel
        absolutActiveTab={absolutActiveTab}
        setAbsolutActiveTab={setAbsolutActiveTab}
      />
    </div>
  );
};

export default HeaderDesk;
